import api from "../../api";

export const AllStats = async (token) => {
  try {
    const res = await api.get("admin/count", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};
